import { FCW } from '../../types.ts';
import { SearchAddressContext } from './SearchAddressContext.ts';

import {
  AddressLookup,
  AddressLookupStatus,
  AddressSearch,
  AddressSearchStatus,
  LocationDetailsResponse,
  LocationPredictionResponse,
} from '@/searchAddress/AddressTypes.ts';
import { useSearchAddressActions } from '@/searchAddress/actions/useSearchAddressActions.ts';

export interface SearchAddressApi {
  searchStatus: AddressSearchStatus;
  searchAddress: (address: AddressSearch) => Promise<LocationPredictionResponse>;
  lookupStatus: AddressLookupStatus;
  lookupAddress: (address: AddressLookup) => Promise<LocationDetailsResponse>;
}

export const SearchAddressProvider: FCW = ({ children }) => {
  const { searchStatus, searchAddress, lookupStatus, lookupAddress } = useSearchAddressActions();

  return (
    <SearchAddressContext.Provider
      value={{
        searchStatus,
        searchAddress,
        lookupStatus,
        lookupAddress,
      }}
    >
      {children}
    </SearchAddressContext.Provider>
  );
};
